import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@jem-open/jem-ui";
import { subscribeBlocked } from "./migrationStore";
import { useMigrationStatus } from "./useMigrationStatus";

export const ReadOnlyModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { deepLink } = useMigrationStatus();
  const location = useLocation();

  useEffect(() => subscribeBlocked(() => setOpen(true)), []);

  const href = deepLink(location.pathname);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>This action now lives in the new Jem Hub</DialogTitle>
          <DialogDescription>
            Your company has moved to the new Jem Hub. This dashboard is
            view-only, but everything you need is one click away.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            Stay here
          </Button>
          <Button asChild>
            <a href={href} target="_blank" rel="noopener noreferrer">
              Take me there
            </a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReadOnlyModal;
